import { render, staticRenderFns } from "./FirstNationsFilter.vue?vue&type=template&id=0875211a"
import script from "./FirstNationsFilter.vue?vue&type=script&lang=js"
export * from "./FirstNationsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports